import React, { Component } from 'react';
import { connect } from 'react-redux';

import LocalText from '../../../localization/local_text';

import getNextUrl from '../../../util/get_next_url';

class SelectLanguage extends Component {
  render() {
    return (
      <ul className={`subGnb_dp2 ${this.props.siteMap && 'siteMapMode'}`}>
        <li className="subGnb_dp2_list">
          <a
            className={`subGnb_link ${this.props.mode === 'ko' && 'on'}`}
            href={getNextUrl(window.location.href)}
            onClick={function () {
              this.props.onClick('ko');
            }.bind(this)}
          >
            <LocalText txt={'header_kor'} />
          </a>
        </li>
        <li className="subGnb_dp2_list">
          <a
            className={`subGnb_link ${this.props.mode === 'en' && 'on'}`}
            href={getNextUrl(window.location.href)}
            onClick={function () {
              this.props.onClick('en');
            }.bind(this)}
          >
            <LocalText txt={'header_eng'} />
          </a>
        </li>
      </ul>
    );
  }

  selectedLan() {
    return this.props.mode;
  }
}

//Selected={this.props.store.mapStateToProps()}

const mapStateToProps = (state) => state;

export default connect(mapStateToProps, function (dispatch) {
  return {
    onClick: function (mode) {
      dispatch({ type: 'CHANGE_MODE', mode: mode });
      // 바뀐 언어 적용은 페이지 리프레시 되면서 자동으로 적용되므로, i18n 업데이트 호출 안함.
      //i18n.changeLanguage(mode);
    },
  };
})(SelectLanguage);
